// extracted by mini-css-extract-plugin
export default {"headerContainer":"Ff_0E49wYM31QSGUzNW2","headerText":"UgKv3Odv4byUxikpiLmc"};